import { ViewSchema } from "@storytell/types";
import { RequestBuilder } from "../requestBuilder";
import { CreateViewInputSchema, UpdateViewInputSchema, ViewIdParamsSchema, ViewsSyncSchema } from "./viewClient.types";

export const ViewsSyncRequestConfig = new RequestBuilder({
  path: () => "/views-sync",
  responseSchema: ViewsSyncSchema,
}).withIncludeProjectId();

export const CreateViewRequestConfig = new RequestBuilder({
  path: () => "/views",
  responseSchema: ViewSchema,
  bodySchema: CreateViewInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const DeleteViewRequestConfig = new RequestBuilder({
  paramsSchema: ViewIdParamsSchema,
  path: (params) => `/views/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined)
  .withIncludeProjectId();

export const UpdateViewRequestConfig = new RequestBuilder({
  paramsSchema: ViewIdParamsSchema,
  path: ({ id }) => `/views/${id}`,
  responseSchema: ViewSchema,
  bodySchema: UpdateViewInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();
